/**
 * Trusted by experts — Swiper carousel, equal-height cards, theme editor reload.
 */
(function () {
  const ROOT = '[data-relab-experts]';

  function destroy(root) {
    if (root._relabExpertsResize) {
      window.removeEventListener('resize', root._relabExpertsResize);
      root._relabExpertsResize = null;
    }
    if (root._relabExpertsSwiper) {
      root._relabExpertsSwiper.destroy(true, true);
      root._relabExpertsSwiper = null;
    }
    const el = root.querySelector('.relab-experts__swiper');
    if (el) delete el.dataset.swiperInitialized;
    root.querySelectorAll('.relab-experts__col, .relab-experts__card').forEach((node) => {
      node.style.minHeight = '';
    });
  }

  function equalizeHeights(root) {
    const cols = root.querySelectorAll(
      '.relab-experts__swiper .swiper-slide:not(.swiper-slide-duplicate) .relab-experts__col'
    );
    const cards = root.querySelectorAll(
      '.relab-experts__swiper .swiper-slide:not(.swiper-slide-duplicate) .relab-experts__card'
    );
    if (!cards.length) return;

    cols.forEach((col) => {
      col.style.minHeight = '';
    });
    cards.forEach((card) => {
      card.style.minHeight = '';
    });

    let max = 0;
    cards.forEach((card) => {
      max = Math.max(max, card.scrollHeight, card.getBoundingClientRect().height);
    });

    if (max > 0) {
      const px = `${Math.ceil(max)}px`;
      cols.forEach((col) => {
        col.style.minHeight = px;
      });
      cards.forEach((card) => {
        card.style.minHeight = px;
      });
    }
  }

  function scheduleEqualize(root, swiper) {
    window.requestAnimationFrame(() => {
      equalizeHeights(root);
      if (swiper && !swiper.destroyed && typeof swiper.update === 'function') {
        swiper.update();
      }
    });
  }

  function bindImageLoadEqualize(root, swiper) {
    root.querySelectorAll('.relab-experts__media img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => scheduleEqualize(root, swiper), { once: true });
    });
  }

  function syncNavVisibility(root, swiper) {
    const nav = root.querySelector('.relab-experts__nav');
    if (!nav || !swiper) return;
    nav.hidden = !!swiper.isLocked;
  }

  function init(root, attempt) {
    const swiperEl = root.querySelector('.relab-experts__swiper');
    if (!swiperEl || swiperEl.dataset.swiperInitialized === '1') return;

    const n = typeof attempt === 'number' ? attempt : 0;
    if (typeof window.Swiper === 'undefined') {
      if (n < 80) window.setTimeout(() => init(root, n + 1), 50);
      return;
    }

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    const gap = parseInt(root.dataset.expertsGap, 10);
    const spaceBetween = Number.isNaN(gap) ? 12 : gap;
    const prevEl = root.querySelector('.relab-experts__arrow--prev');
    const nextEl = root.querySelector('.relab-experts__arrow--next');

    const options = {
      slidesPerView: 'auto',
      spaceBetween,
      grabCursor: slideCount > 1,
      watchOverflow: true,
      autoHeight: false,
      speed: 450,
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween,
        },
      },
      on: {
        init(swiper) {
          scheduleEqualize(root, swiper);
          bindImageLoadEqualize(root, swiper);
          syncNavVisibility(root, swiper);
        },
        resize(swiper) {
          scheduleEqualize(root, swiper);
          syncNavVisibility(root, swiper);
        },
        slideChangeTransitionEnd(swiper) {
          scheduleEqualize(root, swiper);
        },
        lock(swiper) {
          syncNavVisibility(root, swiper);
        },
        unlock(swiper) {
          syncNavVisibility(root, swiper);
        },
      },
    };

    if (slideCount > 1 && prevEl && nextEl) {
      options.navigation = {
        prevEl,
        nextEl,
      };
    }

    root._relabExpertsSwiper = new window.Swiper(swiperEl, options);
    swiperEl.dataset.swiperInitialized = '1';

    root._relabExpertsResize = () => {
      scheduleEqualize(root, root._relabExpertsSwiper);
      syncNavVisibility(root, root._relabExpertsSwiper);
    };
    window.addEventListener('resize', root._relabExpertsResize);
    scheduleEqualize(root, root._relabExpertsSwiper);
    bindImageLoadEqualize(root, root._relabExpertsSwiper);
    syncNavVisibility(root, root._relabExpertsSwiper);
  }

  function initFromSection(sectionEl) {
    const root = sectionEl.matches(ROOT) ? sectionEl : sectionEl.querySelector(ROOT);
    if (!root) return;
    destroy(root);
    init(root);
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach((root) => {
      destroy(root);
      init(root);
    });
  }

  document.addEventListener('shopify:section:load', (ev) => {
    const id = ev.detail && ev.detail.sectionId;
    if (!id) return;
    const section = document.querySelector(`#shopify-section-${id}`);
    if (section) initFromSection(section);
  });

  document.addEventListener('shopify:section:unload', (ev) => {
    const id = ev.detail && ev.detail.sectionId;
    if (!id) return;
    const section = document.querySelector(`#shopify-section-${id}`);
    const root = section && section.querySelector(ROOT);
    if (root) destroy(root);
  });

  window.addEventListener('load', () => {
    document.querySelectorAll(ROOT).forEach((root) => {
      scheduleEqualize(root, root._relabExpertsSwiper);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
